import Button from '@ds/components/actions/Button';
import { LogoutIcon } from '@ds/icons/generated/material';
import useLogoutRedirect from '@effects/useLogoutRedirect';
import React from 'react';

const LogoutButton = () => {
    const logoutRedirect = useLogoutRedirect();

    return (
        <Button
            onClick={logoutRedirect.action}
            startIcon={<LogoutIcon />}
        >
            {logoutRedirect.text}
        </Button>
    );
};

export default LogoutButton;
